<div #container class="container"></div>
<div class="circles-container">
    <swiper #swiperCircle class="swiper" [config]="swiperCirclesConfig">
        <ng-template class="container-option" *ngFor="let circle of options | async" swiperSlide>
            <div [routerLink]="['/category', circle.slug]" class="circle-option pointer-in"><i class="fa-thin {{ circle.icon }} icon-primary fa-3x"></i></div>
            <p [routerLink]="['/category', circle.slug]" class="name-option pointer-in">{{ circle.nombre }}</p>
        </ng-template>
    </swiper>    
</div>